import * as Yup from 'yup';
// import * as moment from 'moment';
// import { FORMAT, BIDFORMAT } from '../utils/dateOfBirthValidation';

export function getInitialValues(data) {
    return {
        editStateTaxExemption: data.state || '',
        editTaxExemption: false,
    }
}
const VALIDATION_SCHEMA = Yup.object().shape({
});

export { VALIDATION_SCHEMA };